export default [
  {
    path: 'course-total',
    component: resolve => require(['@/components/learning-center/u-gear/CourseTotal'], resolve),
  },
  {
    path: 'u-school-info',
    component: resolve => require(['@/components/learning-center/u-gear/UschoolInfo'], resolve),
  },
  {
    path: 'contract-info',
    component: resolve => require(['@/components/learning-center/u-gear/ContractInfo'], resolve),
  },
  {
    path: 'choose-class',
    component: resolve => require(['@/components/learning-center/u-gear/ChooseClass'], resolve),
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/learning-center/u-gear/index.js